module.exports = __webpack_public_path__ + "static/media/download2.ea8f8b74.jpeg";